import React from 'react';
import classNames from 'classnames';
import SpinnerDots from '../spinner/dots';
import './report-renderer.scss';

const ReportPaginate = props => {
    if (props.report.numPages < 2) return null;

    const buildPages = [];

    for (let i = 0; i < props.report.numPages; i++) {
        buildPages.push(i+1);
    }

    return (
        <div className="paginate paginate--small">
            <ul className="paginate__pages">
                {props.report.currentPage !== 1 &&
                    <li>
                        <button className="paginate__nav paginate__nav--prev" type="button" disabled={props.isLoading || props.report.currentPage === 1} onClick={() => {
                                if (props.isLoading) return;
                                props.loadReport(props.report.currentPage-1, true)
                            }}></button>
                    </li>
                }
                {buildPages.map((page, i) => {
                    return (
                        <li key={`page${i}`}><button className={classNames({
                            'paginate__page': true,
                            'paginate__page--is-selected': page === props.report.currentPage
                        })} onClick={() => {
                            if (props.isLoading) return;
                            props.loadReport(page, true);
                        }}>{page}</button></li>
                    );
                })}
                <li>
                    {props.report.currentPage !== buildPages.length &&
                        <button className="paginate__nav paginate__nav--next" type="button" disabled={props.isLoading || props.report.numPages === props.report.currentPage} onClick={() => {
                            if (props.isLoading) return;
                            props.loadReport(props.report.currentPage+1, true)}
                        }></button>
                    }
                </li>
            </ul>            
        </div>
    );
}

const ReportRenderer = props => {
    return (
        <section className={classNames({
            'report-renderer-outer': true,
            'report-renderer-outer--is-loading': props.isLoading
        })}>
            <div className={classNames({
                'report-renderer': true,
                'report-renderer--is-loading': props.isLoading,
                'report-renderer--is-paginating': props.isPaginating
            })}>

                {props.report && props.report.html &&
                    <div className="report-renderer__content">
                        <div className="report-renderer__padding">
                            <div className="report-renderer__data" dangerouslySetInnerHTML={{ __html: props.report.html }}></div>
                            <div className="report-renderer__controls">
                                <ReportPaginate {...props} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        
            <SpinnerDots />
        </section>
    );
};

export default ReportRenderer;